import { useState } from "react";
import { creatorFetch } from "../adminApi";
import { Field, ImageField, SaveBar } from "../admin/sections";
import { Avatar } from "./bits";

/* প্রোফাইল — নিজের পরিচয়, পাসওয়ার্ড আর আমার QR */
export default function ProfileTab({ creator, refresh }) {
  const [f, setF] = useState({
    name: creator.name || "",
    photo: creator.photo || "",
    bio: creator.bio || "",
    location: creator.location || "",
    craft: creator.craft || "",
    languages: creator.languages || "",
    contact: creator.contact || "",
    story: creator.story || "",
    years: creator.years ?? 0,
  });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const save = async () => {
    setErr("");
    try {
      await creatorFetch("/creator/profile", { method: "PUT", body: JSON.stringify(f) });
      setDone(true);
      refresh();
      setTimeout(() => setDone(false), 2500);
    } catch (e) {
      setErr(e.message);
    }
  };

  return (
    <div className="max-w-2xl space-y-6" data-testid="creator-section-profile">
      <div className="flex items-center gap-4">
        <Avatar photo={f.photo} name={f.name} size="h-16 w-16" />
        <p className="text-sm text-sand/60">নিজের ছবি বসান — গ্রামবাসী এটাই দেখবে।</p>
      </div>
      <Field label="নাম" value={f.name} onChange={(v) => setF({ ...f, name: v })} testid="profile-name" />
      <ImageField label="ছবির ঠিকানা" value={f.photo} onChange={(v) => setF({ ...f, photo: v })} />
      <Field label="ছোট পরিচয়" value={f.bio} onChange={(v) => setF({ ...f, bio: v })} area testid="profile-bio" />
      <div className="grid gap-4 sm:grid-cols-2">
        <Field label="ঠিকানা" value={f.location} onChange={(v) => setF({ ...f, location: v })} testid="profile-location" />
        <Field label="কারুকাজ / শিল্প-ঘরানা" value={f.craft} onChange={(v) => setF({ ...f, craft: v })} testid="profile-craft" />
        <Field label="ভাষা" value={f.languages} onChange={(v) => setF({ ...f, languages: v })} testid="profile-languages" />
        <Field label="যোগাযোগ (ফোন)" value={f.contact} onChange={(v) => setF({ ...f, contact: v })} testid="profile-contact" />
        <Field label="অভিজ্ঞতা (বছর)" value={String(f.years ?? 0)} onChange={(v) => setF({ ...f, years: Number(v) || 0 })} testid="profile-years" />
      </div>
      <Field label="নিজের গল্প" value={f.story} onChange={(v) => setF({ ...f, story: v })} area testid="profile-story" />
      {err && <p className="text-xs text-red-300">{err}</p>}
      <SaveBar saving={false} done={done} onSave={save} testid="save-profile" />

      {/* আমার QR */}
      <div className="rounded-2xl border border-gold/20 bg-earthen/70 p-6 text-center" data-testid="qr-card">
        <p className="font-display text-xl text-gold">আমার RONG-O-MATI QR</p>
        <p className="mt-1 text-xs text-sand/55">প্রোটোটাইপ — এই ছবিটাই এখন আপনার ঘরের দরজার টিকেট</p>
        <QrPlaceholder seed={creator.email || "rong"} />
        <p className="mt-3 text-[11px] text-sand/45">আসল QR শীঘ্রই — স্ক্যান করলেই আপনার দোকান/মঞ্চ খুলবে</p>
      </div>
    </div>
  );
}

/* QR-চেহারা — আলপনা-ঘরের স্থায়ী ছবি */
function QrPlaceholder({ seed }) {
  const n = 11;
  let h = 0;
  for (const c of seed) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  const cell = (i, j) => {
    h = (h * 1103515245 + 12345) >>> 0;
    return ((h >>> 16) & 1) === 1;
  };
  const cells = [];
  for (let i = 0; i < n; i++) {
    for (let j = 0; j < n; j++) {
      const corner = (i < 3 && j < 3) || (i < 3 && j >= n - 3) || (i >= n - 3 && j < 3);
      if (corner) {
        cells.push(<rect key={`${i}-${j}`} x={j * 10} y={i * 10} width="10" height="10" fill="#e8b54d" opacity={i === 1 && j === 1 ? 1 : (i + j) % 2 ? 1 : 0.55} />);
      } else if (cell(i, j)) {
        cells.push(<rect key={`${i}-${j}`} x={j * 10 + 1.5} y={i * 10 + 1.5} width="7" height="7" rx="1.5" fill="#e8b54d" opacity="0.85" />);
      }
    }
  }
  return (
    <svg viewBox="-6 -6 122 122" className="mx-auto mt-5 h-40 w-40 rounded-xl border border-gold/25 bg-plaster p-1" data-testid="qr-placeholder">
      {cells}
    </svg>
  );
}
